<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <router-view class="height-full" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "IndexKasKecil",
  components: {},
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  computed: {
    ...mapGetters(["getScreen"]),
  },
};
</script>

<style>
</style>